module.exports = __webpack_public_path__ + "img/ss.ca2f7d83.svg";